export function PageName (pg) {
  if (!pg)
    return process.env.VUE_APP_TITLE;
  else
    return pg + " - " + process.env.VUE_APP_TITLE;
}